// import Splide from '@splidejs/splide';
// import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.hero-banner .controls button' ).on( 'click', function() {
        if ( $( this ).hasClass( 'is-paused' ) ) {
          $( this ).attr( 'title', 'Pause marquee' ).removeClass( 'is-paused' );
          $( '.hero-banner .is-motion-safe' ).show();
          $( '.hero-banner .is-reduced-motion' ).hide();
        } else {
          $( this ).attr( 'title', 'Play marquee' ).addClass( 'is-paused' );
          $( '.hero-banner .is-motion-safe' ).hide();
          $( '.hero-banner .is-reduced-motion' ).show();
        }
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
